import { useSelector } from 'react-redux'
import { Table } from '../../../common/table'
import { TextEllipsisStaticLine } from '../../../common/textEllipsis/TextEllipsisStaticLine'
import { mapTableOfBranches } from '../constants'
import { selectBranchData, selectBranchIds } from '../store/slice'
import { NameCell } from './NameCell'
import PropTypes from 'prop-types'

export const BranchTable = ({ isDynamicReport }) => {
  const ids = useSelector(selectBranchIds)

  return (
    <Table
      autoHeightMax={isDynamicReport ? undefined : 200}
      noDataText="companyAnalysis.ownershipAndGroup.BRANCHES_NO_DATA"
      ids={ids}
      isNoDataWithHead={false}
      isDisplayScroll={!isDynamicReport}
      isStickyFirstCol={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
      getDataFromRedux={selectBranchData}
      schema={Object.values(mapTableOfBranches).map((item) => {
        return {
          colId: item.key,
          title: item.title,
          isI18n: true,
          parentThStyle: isDynamicReport ? {} : item.parentThStyle,
          render: (val, { rowId }) => {
            switch (item.key) {
              case mapTableOfBranches.organizationName.key:
                return (
                  <NameCell
                    item={item}
                    rowId={rowId}
                    val={val}
                    isDynamicReport={isDynamicReport}
                  />
                )

              case mapTableOfBranches.address.key:
                return isDynamicReport ? (
                  item.format(val)
                ) : (
                  <TextEllipsisStaticLine
                    lineClamp={2}
                    text={item.format(val)}
                  />
                )

              default:
                return item.format(val)
            }
          },
        }
      })}
    />
  )
}

BranchTable.propTypes = {
  isDynamicReport: PropTypes.bool,
}
